// src/features/sw-message-handler.tsx
import { useEffect } from "react";
import { useAuth } from "@/providers/auth-provider";
import { MessageQueue } from "@/lib/message-queue";

// const PUSH_CHANNELS = {
//   CHAT: "chat", // 채팅 메시지
//   FRIEND: "friend", // 친구 요청
//   SYSTEM: "system", // 시스템 알림
//   MENTION: "mention", // 멘션/태그 알림
// } as const;

export const serviceworkerMessageQueue = new MessageQueue();

export const sendMessageToServiceWorker = async (message: any) => {
  if ("serviceWorker" in navigator) {
    const registration = await navigator.serviceWorker.ready;
    if (registration.active) {
      registration.active.postMessage(message);
    } else {
      console.error("Service worker is not active");
    }
  } else {
    console.error("Service worker is not supported");
  }
};

export function ServiceWorkerMessageHandler() {
  const { user } = useAuth();

  const messageHandler = async (event: MessageEvent) => {
    const messagePayload = event.data;

    if (!messagePayload) {
      console.warn("[s-message] No message payload received");
      return;
    }

    if (user._id === messagePayload.userId) {
      console.log("[s-message] Received message: ", messagePayload);
      serviceworkerMessageQueue.enqueue(messagePayload);
    } else {
      console.warn(
        "[s-message] Ignore message for other user",
        user._id,
        messagePayload,
      );
    }
  };

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    if (!user?._id) return;

    // 메시지 이벤트 리스너 등록
    navigator.serviceWorker.addEventListener("message", messageHandler);
    // cleanup
    return () => {
      navigator.serviceWorker.removeEventListener("message", messageHandler);
    };
  }, [user?._id]);

  return null;
}
